import React, {useContext} from "react";
import useTranslate from "../../../../modules/local/useTranslate";
import EventContext from "../EventContext";
import Members from "../../../MemberSetting/Members.lazy";

export const EventSettingMembers = ({}) => {
    const t = useTranslate()
    const {event} = useContext(EventContext)

    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between gap-2">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t('member')}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                </div>
            </div>
            <Members item={event}/>
        </div>
    )
}